/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import {
  ListRemoteSessionClientsResult,
  ListRemoteSessionClientsResult$inboundSchema,
} from "../components/listremotesessionclientsresult.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListRemoteSessionClientsSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ListRemoteSessionClientsSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ListRemoteSessionClientsSecurity = {
  option1?: ListRemoteSessionClientsSecurityOption1 | undefined;
  option2?: ListRemoteSessionClientsSecurityOption2 | undefined;
};

export type ListRemoteSessionClientsRequest = {
  /**
   * Filter to clients registered with this issuer.
   */
  remoteSessionIssuerId?: string | undefined;
  /**
   * Filter to clients paired with this user_session_issuer.
   */
  userSessionIssuerId?: string | undefined;
  /**
   * Pagination cursor.
   */
  cursor?: string | undefined;
  /**
   * Page size (default 50, max 100).
   */
  limit?: number | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

export type ListRemoteSessionClientsResponse = {
  result: ListRemoteSessionClientsResult;
};

/** @internal */
export type ListRemoteSessionClientsSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ListRemoteSessionClientsSecurityOption1$outboundSchema:
  z.ZodMiniType<
    ListRemoteSessionClientsSecurityOption1$Outbound,
    ListRemoteSessionClientsSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function listRemoteSessionClientsSecurityOption1ToJSON(
  listRemoteSessionClientsSecurityOption1:
    ListRemoteSessionClientsSecurityOption1,
): string {
  return JSON.stringify(
    ListRemoteSessionClientsSecurityOption1$outboundSchema.parse(
      listRemoteSessionClientsSecurityOption1,
    ),
  );
}

/** @internal */
export type ListRemoteSessionClientsSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ListRemoteSessionClientsSecurityOption2$outboundSchema:
  z.ZodMiniType<
    ListRemoteSessionClientsSecurityOption2$Outbound,
    ListRemoteSessionClientsSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function listRemoteSessionClientsSecurityOption2ToJSON(
  listRemoteSessionClientsSecurityOption2:
    ListRemoteSessionClientsSecurityOption2,
): string {
  return JSON.stringify(
    ListRemoteSessionClientsSecurityOption2$outboundSchema.parse(
      listRemoteSessionClientsSecurityOption2,
    ),
  );
}

/** @internal */
export type ListRemoteSessionClientsSecurity$Outbound = {
  Option1?: ListRemoteSessionClientsSecurityOption1$Outbound | undefined;
  Option2?: ListRemoteSessionClientsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ListRemoteSessionClientsSecurity$outboundSchema: z.ZodMiniType<
  ListRemoteSessionClientsSecurity$Outbound,
  ListRemoteSessionClientsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ListRemoteSessionClientsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ListRemoteSessionClientsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function listRemoteSessionClientsSecurityToJSON(
  listRemoteSessionClientsSecurity: ListRemoteSessionClientsSecurity,
): string {
  return JSON.stringify(
    ListRemoteSessionClientsSecurity$outboundSchema.parse(
      listRemoteSessionClientsSecurity,
    ),
  );
}

/** @internal */
export type ListRemoteSessionClientsRequest$Outbound = {
  remote_session_issuer_id?: string | undefined;
  user_session_issuer_id?: string | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const ListRemoteSessionClientsRequest$outboundSchema: z.ZodMiniType<
  ListRemoteSessionClientsRequest$Outbound,
  ListRemoteSessionClientsRequest
> = z.pipe(
  z.object({
    remoteSessionIssuerId: z.optional(z.string()),
    userSessionIssuerId: z.optional(z.string()),
    cursor: z.optional(z.string()),
    limit: z.optional(z.int()),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      remoteSessionIssuerId: "remote_session_issuer_id",
      userSessionIssuerId: "user_session_issuer_id",
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function listRemoteSessionClientsRequestToJSON(
  listRemoteSessionClientsRequest: ListRemoteSessionClientsRequest,
): string {
  return JSON.stringify(
    ListRemoteSessionClientsRequest$outboundSchema.parse(
      listRemoteSessionClientsRequest,
    ),
  );
}

/** @internal */
export const ListRemoteSessionClientsResponse$inboundSchema: z.ZodMiniType<
  ListRemoteSessionClientsResponse,
  unknown
> = z.pipe(
  z.object({
    Result: ListRemoteSessionClientsResult$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "Result": "result",
    });
  }),
);

export function listRemoteSessionClientsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListRemoteSessionClientsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListRemoteSessionClientsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListRemoteSessionClientsResponse' from JSON`,
  );
}
